/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartRecommenderAPI
 * @hideconstructor
 *
 * @classdesc
 */
define([], () => {
	class DeprecatedVisualizationSmartsRecommenderAPI {
		/**
		 * @function DeprecatedVisualizationSmartsRecommenderAPI#getRecommendedTitle
		 * @description Get the recommended title of the visualization
		 * 
		 *
		 * @param {String} title 
		 *
		 */
		getRecommendedTitle() {}

		/**
		 * @function DeprecatedVisualizationSmartsRecommenderAPI#getRecommendedVisualizations
		 * @description Get the list of recommended visualizations definitions
		 * 
		 *
		 * @param {Object[]} vizDefinitions
		 *
		 */
		getRecommendedVisualizations() {}

		/**
		 * @function DeprecatedVisualizationSmartsRecommenderAPI#recommendAlternateVisualizationsAsWidgetSpecs
		 * 
		 * 
		 * @deprecated
		 */
		recommendAlternateVisualizationsAsWidgetSpecs() {}

		/**
		 * @function DeprecatedVisualizationSmartsRecommenderAPI#recommendRelatedVisualizationsAsWidgetSpecs
		 *
		 * 
		 * @deprecated
		 *
		 */
		recommendRelatedVisualizationsAsWidgetSpecs() {}

		/**
		 * @function DeprecatedVisualizationSmartsRecommenderAPI#recommendCompareVisualizationsAsWidgetSpecs
		 *
		 * 
		 * @deprecated
		 *
		 */
		recommendCompareVisualizationsAsWidgetSpecs() {}

	}

	return DeprecatedVisualizationSmartsRecommenderAPI;
});
